import React, { useState } from 'react';
import "./navbar.css";

import { MdTravelExplore } from 'react-icons/md';
import { AiFillCloseCircle } from 'react-icons/ai';
import { TbGridDots } from 'react-icons/tb';

export const Navbar = () => {
  const [active, setActive] = useState('navBar');

  // Function to toggle navBar
  const showNav = () => {
    setActive('navBar activeNavbar');
  };

  // Function to remove navBar
  const removeNavbar = () => {
    setActive('navBar');
  };

  return (
    <section className='navBarSection'>
      <header className='header flex'>
        <div className='logoDiv'>
          <a href='#' className='logo flex'>
            <h1><MdTravelExplore className='icon' /> Tally Holidays</h1>
          </a>
        </div>

        <div className={active}>
          <ul className='navList flex'>
            <li className='navItem'>
              <a href='#' className='navLink'>მთავარი</a>
            </li>

            <li className='navItem'>
              <a href='#' className='navLink'>პაკეტები</a>
            </li>

            <li className='navItem'>
              <a href='#' className='navLink'>მაღაზია</a>
            </li>

            <li className='navItem'>
              <a href='#' className='navLink'>ჩვენს შესახებ</a>
            </li>

            <li className='navItem'>
              <a href='#' className='navLink'>გვერდები</a>
            </li>

            <li className='navItem'>
              <a href='#' className='navLink'>სიახლეები</a>
            </li>

            <li className='navItem'>
              <a href='#' className='navLink'>კონტაქტი</a>
            </li>

            <button className='btn'>
              <a href="#">დაჯავშნა</a>
            </button>
          </ul>

          <div onClick={removeNavbar} className="closeNavbar">
            <AiFillCloseCircle className='icon' />
          </div>
        </div>

        <div onClick={showNav} className="toggleNavbar">
          <TbGridDots className='icon' />
        </div>
      </header>
    </section>
  );
};

export default Navbar;
